// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkFragmentDoc } from '../../cms/index.generated';
export const FooterItemLinkListFragmentDoc = gql`
    fragment footerItemLinkList on FooterColumnItemLinkList {
  links {
    text
    link {
      ...link
    }
  }
}
    ${LinkFragmentDoc}`;